import { API_REQUEST } from "../actions/api";
import { UPDATE_API_PROCESSING, UPDATE_API_ERROR } from "../actions/ui";
import { showNotification } from "../actions/notification";
import locale from "../../utils/locale";
import {SET_VERIFIED} from "../actions/ui"

export const apiMdl = ({ dispatch, getState }) => next => action => {
  if (action.type === API_REQUEST) {
    const { method, url, onSuccess, onError, retry } = action.meta;
    let request;
    dispatch({ type: UPDATE_API_PROCESSING, payload: true });

    if (method === "GET") {
      request = prepareGetData(url);
    }

    if (method === "POST" || method === "PUT") {
      request = preparePostData(url, action.payload, method);
    }

    if (request) {
      request
        .then(response => response.json())
        .then(data => {
          dispatch({ type: UPDATE_API_PROCESSING, payload: false });
          if (data.status === "success" || data.status === "Success") {
            dispatch({ type: UPDATE_API_ERROR, payload: false });
            if (onSuccess) {
              dispatch({ type: onSuccess, payload: data });
            }
          } else if (data.status === "error") {
            dispatch({ type: UPDATE_API_ERROR, payload: false });
            if (onError) {
              let errorMessage = parseErrorMessage(data.errors);
              dispatch({ type: onSuccess, payload: { ...errorMessage, ...data} });
            } else {
              dispatch(showNotification(locale("api_failure")));
            }
          } else {
            dispatch({ type: UPDATE_API_ERROR, payload: false });
            dispatch({ type: onSuccess, payload: data });
          }
        })
        .catch(error => {
          dispatch({ type: UPDATE_API_PROCESSING, payload: false });
          dispatch({ type: UPDATE_API_ERROR, payload: true });
          if (onError) {
            dispatch({ type: onError, payload: error });
          } else {
            dispatch(showNotification(locale("api_failure")));
          }
        });
    }
  }
  return next(action);
};

const preparePostData = (url = ``, data = {}, post = "POST") => {
  return fetch(url, {
    method: post,
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify(data)
  });
};

const prepareGetData = (url = ``) => {
  return fetch(url, {
    method: "GET"
  });
};

const parseErrorMessage = errors => {
  let errorMessage = "";
  errors.forEach(i => {
    errorMessage += Object.values(i)[0] + " ";
  });
  return {message: errorMessage, messageType: "error"};
};



// WEBPACK FOOTER //
// ./src/redux/middleware/api.js